import React from 'react';
import { withStyles } from '@material-ui/core';
import TabContainer from './TabContainer';
import AssetGridHeader from './AssetGridHeader';
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import { compose } from 'recompose';
import TrailerMap from './Trailer/Map';
import appConstants from '../../../../appConstants';
import { getDataWithQueryString, postData } from '../../../../api/componentAPIs';
import { observer, inject } from 'mobx-react';
import { csvFormulaInjectionSanitizer } from '../../../../utilities/csvUtils';
import styles from './styles';
import UpdateEquipmentForm from './UpdateEquipmentForm';
import { isEqual } from 'lodash/lang';
import { withAppConfig } from '../../../../appConfigContext';
import { withSnackbar } from 'notistack';

const EQUIPMENT_ID = ['trailerId', 'tractorId', 'dollyId'];
const EQUIPMENT_STATUS = ['trailerStatus', 'tractorStatus', 'dollyStatus'];
const LIST_NAME = ['trailer', 'tractor', 'dolly'];
const EQUIPMENT_NUMBER = ['trailerNumber', 'tractorNumber', 'dollyNumber'];
@inject('DispatchStore')
@observer
class AssetManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabId: 0,
      gridApi: null,
      showTrailerMap: false,
      dataList: null,
      errorMessage: appConstants.GRID_STATUS.LOADING,
      equipmentType: appConstants.EQUIPMENT_TYPES[appConstants.EQUIPMENT_TAB_NAME[0]],
      selectedAssets: [],
      searchText: '',
      isAssetUpdateFormOpen: false,
      assetInfo: null,
      statusRules: [],
      terminalRules: [],
      updateInProgress: false,
      formErrorMessage: null
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getEquipmentDetails(this.state.equipmentType, true);
    this.getEquipmentStatusRules();
    this.getEquipmentsTerminalsMoveRules();
    this.props.DispatchStore.setTabName(appConstants.EQUIPMENT_TAB_NAME[this.state.tabId]);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.getEquipmentDetails(this.state.equipmentType, true);
      this.getEquipmentsTerminalsMoveRules();
      this.closeUpdateAssetForm();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateSearchText = (searchText) => {
    this.setState({
      searchText
    });
  };

  getEquipmentDetails = (equipmentType, initialCall = false) => {
    if (initialCall) {
      this.setState({
        errorMessage: appConstants.GRID_STATUS.LOADING
      });
    }
    getDataWithQueryString(
      'GetAllEquipment',
      `terminalCode=${this.props.userData.userProfile.terminal.code}&equipmentType=${equipmentType}`
    ).then((allEquipmentRes) => {
      if (this._isMounted && allEquipmentRes?.status === 200) {
        this.setState({
          dataList: allEquipmentRes.data,
          errorMessage: appConstants.GRID_STATUS.SUCCESS
        });
      } else {
        this.setState({
          dataList: null,
          errorMessage: appConstants.GRID_STATUS.ERROR
        });
      }
    });
  };

  getEquipmentDataById = ({ equipmentId }) => {
    const equipmentNumberParam = equipmentId ? `&equipmentId=${equipmentId}` : '';
    const params = `terminalCode=${this.props.userData.userProfile.terminal.code}&equipmentType=${this.state.equipmentType}${equipmentNumberParam}`;
    getDataWithQueryString('GetAllEquipment', params).then((response) => {
      if (this._isMounted && response?.status === 200) {
        const listName = `${LIST_NAME[this.state.tabId]}`;
        this.updateAssetList(response.data[listName][0] || null, listName, equipmentId);
      }
    });
  };

  updateAssetList = (data, listName, equipmentId) => {
    const assetIndex = this.getExistingAssetIndex(
      this.state.dataList[listName],
      data ? data[EQUIPMENT_ID[this.state.tabId]] : equipmentId,
      EQUIPMENT_ID[this.state.tabId]
    );
    let updatedList = this.state.dataList[listName];
    if (
      assetIndex === -1 &&
      data &&
      data.inboundTerminal === this.props.userData.userProfile.terminal.code
    ) {
      //if index not match will push asset info in asset list :add
      updatedList = [...updatedList, { ...data }];
    } else {
      updatedList = this.getUpdatedList(updatedList, assetIndex, data);
    }
    this.updateAssetStates(updatedList, listName);
  };

  updateAssetStates = (updatedList, listName) => {
    const { tabId, assetInfo } = this.state;
    const validAssetList = this.getValidAssetList(updatedList, tabId);
    const updatedAssetInfo = assetInfo
      ? validAssetList.find(
          (asset) =>
            asset[EQUIPMENT_ID[this.state.tabId]] === assetInfo[EQUIPMENT_ID[this.state.tabId]]
        )
      : null;

    this.setState((state) => ({
      dataList: {
        ...state.dataList,
        [listName]: updatedList
      },
      assetInfo: updatedAssetInfo
    }));
    if (!updatedAssetInfo) {
      this.closeUpdateAssetForm();
    }
  };

  getUpdatedList = (list, assetIndex, data) => {
    return list.reduce((updatedList, asset, index) => {
      if (!data && assetIndex === index) {
        //if there is no data and index match will remove that asset from list : remove
        return updatedList;
      } else if (data && assetIndex === index) {
        if (data.inboundTerminal !== this.props.userData.userProfile.terminal.code) {
          // if there is data and inboundTerminal will not match current terminal remove that asset from list : remove
          return updatedList;
        }
        // if index match will update asset in list : update
        return [...updatedList, { ...asset, ...data }];
      } else {
        return [...updatedList, { ...asset }];
      }
    }, []);
  };

  getExistingAssetIndex = (data, id, key) => {
    return data.findIndex((value) => value[key] === id);
  };

  getEquipmentStatusRules = () => {
    getDataWithQueryString(
      'GetEquipmentStatusRules',
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    ).then((response) => {
      if (response?.status === 200) {
        this.setState({
          statusRules: response.data
        });
      } else {
        this.setState({
          statusRules: []
        });
      }
    });
  };

  getEquipmentsTerminalsMoveRules = () => {
    getDataWithQueryString(
      'GetEquipmentsTerminalsMoveRules',
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    ).then((response) => {
      if (response?.status === 200) {
        this.setState({
          terminalRules: response.data
        });
      } else {
        this.setState({
          terminalRules: []
        });
      }
    });
  };

  handleTabChange = (event, tabId) => {
    if (this.state.tabId !== tabId) {
      const equipmentType = appConstants.EQUIPMENT_TYPES[appConstants.EQUIPMENT_TAB_NAME[tabId]];
      this.setState(
        {
          tabId: tabId,
          equipmentType,
          searchText: '',
          selectedAssets: [],
          isAssetUpdateFormOpen: false,
          updateInProgress: false,
          assetInfo: null,
          formErrorMessage: null
        },
        () => {
          this.getEquipmentDetails(equipmentType, true);
          this.props.DispatchStore.setTabName(appConstants.EQUIPMENT_TAB_NAME[tabId]);
        }
      );
    }
  };

  setGridApi = (value) => {
    this.setState({ gridApi: value });
  };

  onShowMapToggleClick = (val) => {
    this.setState({ showTrailerMap: !val });
  };

  assetSelected = (selectedAssets) => {
    if (!isEqual(selectedAssets, this.state.selectedAssets)) {
      this.setState({ selectedAssets });
    }
  };

  exportCSV = () => {
    if (!this.props.DispatchStore.currentTabName || !this.state.gridApi) {
      return;
    }
    const columns = this.state.gridApi.getColumns();
    const columnKeys = columns
      .filter(column => column.colDef.headerName && column.visible)
      .map(column => column.getColId());
    const params = {
      fileName: this.props.DispatchStore.currentTabName,
      columnKeys,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    this.state.gridApi.exportDataAsCsv(params);
  };

  closeUpdateAssetForm = () => {
    this.setState({
      isAssetUpdateFormOpen: false,
      assetInfo: null,
      updateInProgress: false,
      formErrorMessage: null
    });
  };

  openAssetUpdateForm = (assetInfo) => {
    this.setState({ isAssetUpdateFormOpen: true, assetInfo });
  };

  getDataList = (dataList, tabId) => {
    return dataList ? dataList[`${LIST_NAME[tabId]}`] : [];
  };

  getIdList = (data, key) => {
    return data.map((asset) => asset[key]);
  };

  getValidAssetList = (data, tabId) => {
    const validStatusList = [
      ...new Set(this.state.statusRules?.flatMap((rule) => [rule.status, ...rule.allowedStatus]))
    ];
    return (
      data?.filter(
        (asset) =>
          validStatusList.includes(asset[EQUIPMENT_STATUS[tabId]]) &&
          !['/POWER', '/DOLLY'].includes(asset[EQUIPMENT_NUMBER[tabId]])
      ) || []
    );
  };

  updateEquipmentList = (data) => {
    if (this.state.isAssetUpdateFormOpen && this.state.updateInProgress) {
      this.handleFormEvent(data);
    } else {
      if (data.success) {
        this.getEquipmentDataById(data);
      }
    }
  };

  handleFormEvent = (data) => {
    const equipmentType = LIST_NAME[this.state.tabId];
    if (data.success) {
      if (this.state.assetInfo[EQUIPMENT_ID[this.state.tabId]] === data.equipmentId) {
        this.props.enqueueSnackbar(
          `${appConstants.EQUIPMENT_TAB_NAME[this.state.tabId]} ${
            data.equipmentNumber
          } updated successfully`,
          {
            variant: 'success'
          }
        );
      }
      this.closeUpdateAssetForm();
      this.getEquipmentDataById(data);
    } else {
      this.handleUpdateFail({equipmentType, equipmentNumber: data.equipmentNumber});
    }
  };

  handleUpdateFail = ({equipmentType, equipmentNumber, statusCode}) => {
    this.setState({ updateInProgress: false, formErrorMessage: `Failed to update properties` });
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(`Error while updating ${equipmentType} ${equipmentNumber}`, {
      variant: 'error'
    });
  };

  updateEquipment = (data) => {
    if (data) {
      const { userData } = this.props;
      const { tabId } = this.state;
      const equipmentType = appConstants.EQUIPMENT_TYPES[appConstants.EQUIPMENT_TAB_NAME[tabId]];
      const requestData = {
        ...data,
        terminalCode: userData.userProfile.terminal.code,
        equipmentCategory: equipmentType
      };
      this.setState({ updateInProgress: true });
      postData('UpdateEquipment', requestData).then(
        (response) => {
          if (!(response && response.status >= 200 && response.status < 400)) {
            //api failure case show error message
            this.handleUpdateFail({equipmentType: LIST_NAME[this.state.tabId], equipmentNumber: data.equipmentNumber, statusCode: response.status});
          }
        },
        () => {
          this.handleUpdateFail({equipmentType: LIST_NAME[this.state.tabId], equipmentNumber: data.equipmentNumber});
        }
      );
    }
  };

  clearFormErrorMessage = () => {
    this.setState({ formErrorMessage: null });
  };

  render() {
    const {
      tabId,
      gridApi,
      showTrailerMap,
      dataList,
      errorMessage,
      selectedAssets,
      searchText,
      isAssetUpdateFormOpen,
      assetInfo,
      statusRules,
      terminalRules,
      updateInProgress,
      formErrorMessage
    } = this.state;
    const { classes, glEventHub, userData, configJSON } = this.props;
    const selectedAssetIds = this.getIdList(selectedAssets, EQUIPMENT_ID[tabId]);
    const assetList = this.getDataList(dataList, tabId);
    const validAssetList = this.getValidAssetList(assetList, tabId);
    return (
      <div
        className={`${classes.subModule} ${
          tabId === 0 && showTrailerMap ? classes.withMapModule : ''
        }`}>
        <div className={`${classes.assetManagementModule} subDiv`}>
          <AssetGridHeader
            handleTabChange={this.handleTabChange}
            tabId={tabId}
            gridApi={gridApi}
            userData={userData}
            onShowMapToggleClick={this.onShowMapToggleClick}
            showTrailerMap={showTrailerMap}
            updateSearchText={this.updateSearchText}
            exportCSV={this.exportCSV}
            selectedAssets={selectedAssetIds}
            inputText={searchText}
            isAssetUpdateFormOpen={isAssetUpdateFormOpen}
            openAssetUpdateForm={this.openAssetUpdateForm}
            validAssetIdList={this.getIdList(validAssetList, EQUIPMENT_ID[tabId])}
            validAssetList={validAssetList}
            assetInfo={assetInfo}
            keyId={EQUIPMENT_ID[tabId]}
            enabledEquipmentUpdate={configJSON.enabledEquipmentUpdate || false}
          />
          <TabContainer
            tabId={tabId}
            setGridApi={this.setGridApi}
            glEventHub={glEventHub}
            dataList={assetList}
            showErrorMessage={errorMessage}
            assetSelectedOnGrid={this.assetSelected}
            selectedAssets={selectedAssetIds}
            searchText={searchText}
            getEquipmentDetails={this.getEquipmentDetails}
            updateEquipmentList={this.updateEquipmentList}
            showTrailerScac={configJSON.showTrailerScac || false}
            isAssetUpdateFormOpen={isAssetUpdateFormOpen}      
          />
        </div>
        {tabId === 0 && showTrailerMap && (
          <TrailerMap
            glEventHub={glEventHub}
            trailerList={assetList}
            selectedAssets={selectedAssetIds}
            trailerClickedOnMap={this.assetSelected}
            showTrailerMap={showTrailerMap}
            onShowMapToggleClick={this.onShowMapToggleClick} 
          />
        )}
        {isAssetUpdateFormOpen && assetInfo && (
          <UpdateEquipmentForm
            open={isAssetUpdateFormOpen}
            updateEquipment={this.updateEquipment}
            assetInfo={assetInfo}
            equipmentType={appConstants.EQUIPMENT_TAB_NAME[tabId]}
            statusRules={statusRules}
            terminalRules={terminalRules}
            userData={userData}
            updateInProgress={updateInProgress}
            onClose={this.closeUpdateAssetForm}
            formErrorMessage={formErrorMessage}
            clearFormErrorMessage={this.clearFormErrorMessage}
            tabId={tabId}
            drawerClasses={{
              paper: classes.paperAnchor
            }}
            variant="persistent"
          />
        )}
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withAppConfig,
  withSnackbar
)(AssetManagement);
